const reductions = {

    SET_USER : (state, action) => {
        return action.payload;
    },

    UNSET_USER : () => {
        return null
    }
};

const reducer = (state = null, action) => {
    if(action && action.type && reductions[action.type]) {
        return reductions[action.type](state, action)
    }
    return state;
};

export default reducer;